import React  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    onUpdateColumn,
    setSelectedRow
} from '../../../store/channelmap/reportefectividad/actions';
import { sort_by} from '../../../helpers/commons'

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const ReportEfectividadList = () => {
    const classes = useStyles();
    const columns = useSelector(state => state.reportefectividad.table.columns);
    const loading = useSelector(state => state.reportefectividad.store.loading);
    const order = useSelector(state => state.reportefectividad.table.order);
    const orderBy = useSelector(state => state.reportefectividad.table.orderBy);
    const store = useSelector(state => state.reportefectividad.store);
  
    const dispatch = useDispatch();

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
       let homes = store.data;
       homes.sort(sort_by(property, isAsc, homes[0][property]));

    };

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
             <div style={{ display: 'none' }}>
                <ReactHTMLTableToExcel
                    id="table-xls-button-rpt-indicadores"
                    className=""
                    table="table-to-xls"
                    filename="Rpt_Efectividad"
                    sheet="efectividad"
                    buttonText=""
                />
            </div>   
        <div className={classes.tableWrap}>
            <Table
                columns={columns}
                loading={loading}
                onRowClick={items => dispatch(setSelectedRow(items))}
                onSort={datakey => handleRequestSort(datakey)}
                onUpdateColumn={handleResizeColumn}
                rowCount={store.data.length}
                rowGetter={index => store.data[index]}
                selected={store.selected}
                sortBy={orderBy}
                sortDirection={order}

                
            />
        </div>
    </FieldSet>
    )
};

export default ReportEfectividadList;